module.exports = __webpack_public_path__ + "static/media/brooklyn-street-art.79a3acd7.jpg";